import React, { FC } from 'react'
import Icon from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import { PatientFormated } from '../../../../../../helpers/patientDataManipulations'
import { userAvatarPlaceholderIcn } from '../../../../../../assets/CustomIcons'
import { getImgSRC } from '../../../../../../helpers/fileToBase64'
import { Gender } from '@icure/cardinal-sdk'
import { Tag } from 'antd'
import { getTagColor } from '../../../../../../helpers/getTagColor'

import './index.less'

interface IntroHeaderProps {
  patient: PatientFormated | undefined
  handleMouseEnter: () => void
  handleMouseLeave: () => void
}

export const IntroHeader: FC<IntroHeaderProps> = ({ patient, handleMouseLeave, handleMouseEnter }) => {
  const { t } = useTranslation()
  const { picture, userNameOneString, userDateOfBirthPlusAge, birthSex, tags } = patient || {}
  const getBirthSexTag = () => {
    if (birthSex === Gender.Female) {
      return <Tag color="magenta">{Gender.Female}</Tag>
    } else if (birthSex === Gender.Male) {
      return <Tag color="geekblue">{Gender.Male}</Tag>
    } else {
      return undefined
    }
  }

  const patientAvatarSrc = getImgSRC(picture)
  return (
    <div className="patientIntroHeader" onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
      {patientAvatarSrc ? (
        <div className="patientIntroHeader__picture">
          <img src={patientAvatarSrc} alt={`${userNameOneString} picture`} />
        </div>
      ) : (
        <div className="patientIntroHeader__userAvatarPlaceholder">
          <Icon component={userAvatarPlaceholderIcn} />
        </div>
      )}
      <div className="patientIntroHeader__item ">
        <h3>{userNameOneString}</h3>
      </div>
      {userDateOfBirthPlusAge && (
        <>
          <div className="patientIntroHeader__divider hideOnMobile"></div>
          <div className="patientIntroHeader__item hideOnMobile">
            <p>{userDateOfBirthPlusAge}</p>
          </div>
        </>
      )}
      {getBirthSexTag() && (
        <>
          <div className="patientIntroHeader__divider hideOnMobile"></div>
          <div className="patientIntroHeader__item hideOnMobile">
            <p>{getBirthSexTag()}</p>
          </div>
        </>
      )}
      {tags?.length !== 0 && (
        <>
          <div className="patientIntroHeader__divider hideOnMobile"></div>
          <div className="patientIntroHeader__item hideOnMobile">
            {tags?.map((el, index) => (
              <Tag key={index} color={getTagColor(el.code)}>
                {el.code}
              </Tag>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
